import { Api } from "@/models/base/api";
import { Model } from "@/models/base/model";
import { ReqOption } from "@/models/base/api";
import sysconfig from "@/constants/sysconfig";

export class Collection {
  // プロパティは名前: 型
  name: string;
  url: string;
  params: any;
  model: any;
  models: any;
  reqParams: any;

  constructor() {
    this.name = "";
    this.url = "";
    this.params = {};
    this.model = Model;
    this.models = [];
    this.reqParams = {}
  }

  async fetch(): Promise<any> {

    const reqOption: ReqOption = {
      method: "GET",
      url: this.url,
      params: this.reqParams,
    };

    function uniq(retArray: any) {
      const uniquedArray = [];
      const uniquedArrayIds = [];
      for (const elem of retArray) {
        if (uniquedArrayIds.indexOf(elem._id) < 0) {
          uniquedArray.push(elem);
          uniquedArrayIds.push(elem._id);
        }
      }
      return uniquedArray;
    }

    const api = new Api()
    return await api.fetch(reqOption).then(([response, error]) => {
      if (error) {
        if (sysconfig.common.devmode) {
          console.log("Collection fetch error!", this, error);
        }
        return [this, null, error]
      } else {
        if (!Array.isArray(response.data)) {
          // Objectで返却されるコレクションについてはこの時点で返却する
          const model = new this.model({});
          model.set(response.data);
          this.models.push(model);
          if (sysconfig.common.devmode) {
            console.log("Collection fetch success!", this, response);
          }
          return [this, response, null];
        }

        for (const doc of response.data) {
          const options = {
            id: doc._id
          }
          const model = new this.model(options)
          model.set(doc)
          this.models.push(model)
        }
        if (sysconfig.common.devmode) {
          console.log("Collection fetch success!", this, response);
        }
        return [this, response, null]
      }
    })
  }
}